module.exports = __webpack_public_path__ + "img/app_download_2.9a93e5eb.png";